import { Account } from './account.model';
import { Contract } from './contract.model';
import { DeliveryPoint } from './delivery-point.model';
import { Site } from './site.model';

/**
 * Model for API AccessControlPerimeter Model
 */
export class AccessControlScope {
  /**
   * DeliveryPoint scope for AccessControl
   */
  deliveryPoint?: DeliveryPoint;

  /**
   * Contract scope for AccessControl
   */
  contract?: Contract;

  /**
   * Account scope for AccessControl
   */
  account?: Account;

  /**
   * Site scope for AccessControl
   */
  site?: Site;

  constructor(attributes: Partial<AccessControlScope> = {}) {
    Object.assign(this, attributes);
  }

  toString() {
    return (this.deliveryPoint || this.site || this.contract || this.account || '').toString();
  }

  hasIntersectionWith(scope: AccessControlScope): boolean {
    return (
      this.objectsHasIntersection(this.deliveryPoint, scope.deliveryPoint) &&
      this.objectsHasIntersection(this.contract, scope.contract) &&
      this.objectsHasIntersection(this.account, scope.account) &&
      this.objectsHasIntersection(this.site, scope.site)
    );
  }

  equalTo(scope: AccessControlScope): boolean {
    const scope1 = this.initScope(this);
    const scope2 = this.initScope(scope);

    return (
      scope1.deliveryPoint.equalTo(scope2.deliveryPoint) &&
      scope1.contract.id === scope2.contract.id &&
      scope1.account.id === scope2.account.id &&
      scope1.site.id === scope2.site.id
    );
  }

  private objectsHasIntersection(
    obj1: DeliveryPoint | Contract | Account | Site,
    obj2: DeliveryPoint | Contract | Account | Site,
  ): boolean {
    if (!obj1 || !obj2) {
      return true;
    }

    if (obj1 instanceof DeliveryPoint && obj2 instanceof DeliveryPoint) {
      return obj1.equalTo(obj2);
    }

    if (!(obj1 instanceof DeliveryPoint) && !(obj2 instanceof DeliveryPoint)) {
      return obj1.id === obj2.id;
    }

    return false;
  }

  private initScope(scope: AccessControlScope) {
    return new AccessControlScope({
      deliveryPoint: scope.deliveryPoint || new DeliveryPoint(),
      contract: scope.contract || new Contract(),
      account: scope.account || new Account(),
      site: scope.site || new Site(),
    });
  }
}
